module.exports = __webpack_public_path__ + "img/黎川县中医医院.5aacb0fb.png";